import { render, staticRenderFns } from "./GroupCategorySort.vue?vue&type=template&id=3ab0f03d&scoped=true"
import script from "./GroupCategorySort.vue?vue&type=script&lang=js"
export * from "./GroupCategorySort.vue?vue&type=script&lang=js"
import style0 from "./GroupCategorySort.vue?vue&type=style&index=0&id=3ab0f03d&prod&lang=scss"
import style1 from "./GroupCategorySort.vue?vue&type=style&index=1&id=3ab0f03d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab0f03d",
  null
  
)

export default component.exports